export const baseUrl = process.env.VUE_APP_API_BASE_URL
export const apiUrl = `${baseUrl}/api/partner/`
export const employeeApiUrl = `${baseUrl}/api/employee/`
export const capiUrl = `${baseUrl}/api/customer/`

export const currentUser = {
  token: '',
  user: {},
}
